module.exports = __webpack_public_path__ + "media/images/application/template/map-cluster-markers/m2-d9eebe1c06c3c77692f155e9cd375427.png";